import { createFileRoute, notFound } from "@tanstack/react-router";

import { inputsFromSearch } from "../../../workspaces/reports/inputs";
import { ReportPage } from "../../../workspaces/reports/pages/ReportPage";
import { searchWithView, splitViewSearch } from "../../../workspaces/reports/view";

/* A past version, read only, at its own address so it can be sent. */
export const Route = createFileRoute("/_console/p/$org/$project/reports/$name/versions/$version")({
  beforeLoad: ({ params }) => {
    if (!/^[1-9][0-9]{0,8}$/.test(params.version)) throw notFound();
  },
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> => search,
  component: ReportVersionRoute,
});

function ReportVersionRoute() {
  const { name, version } = Route.useParams();
  const { view, rest } = splitViewSearch(Route.useSearch());
  const navigate = Route.useNavigate();
  const inputs = inputsFromSearch(rest);
  return (
    <ReportPage
      name={name}
      version={Number(version)}
      inputs={inputs}
      onInputs={(next) => void navigate({ search: searchWithView(next, view), replace: true })}
      view={view}
      onView={(next) => void navigate({ search: searchWithView(inputs, next), replace: true })}
    />
  );
}
